const doc = [null];
module.exports = doc.length <= 1 ? doc[0] : doc;